export const DEFAULT_MCAPS_COPILOT_FEATURE_FLAG =
  'Copilot.DefaultToMCAPSHelp.Enabled';

export const GENERIC_MCAPS_COPILOT_APP_NAME = 'mcapshelpgeneric';

export type MCAPSCopilotContext = 'generic' | 'tile';

export const shouldShowIrisOnStartup = (
  isDefaultAgentEnabled: boolean,
  cachedAccess: string | null
): boolean => {
  if (!isDefaultAgentEnabled) {
    return true;
  }

  return cachedAccess === 'false';
};

export const shouldShowCopilotExitButton = (
  isDefaultAgentEnabled: boolean,
  context: MCAPSCopilotContext
): boolean => !isDefaultAgentEnabled || context === 'tile';

export const shouldSuppressInitialIrisOpen = (
  isDefaultAgentEnabled: boolean,
  irisUtterance: unknown,
  chatBotClicked: unknown,
  irisBotIconClicked: unknown
): boolean =>
  isDefaultAgentEnabled &&
  !irisUtterance &&
  !chatBotClicked &&
  !irisBotIconClicked;
